import { render, staticRenderFns } from "./#overview-edit.vue?vue&type=template&id=53327b38&"
import script from "./#overview-edit.vue?vue&type=script&lang=js&"
export * from "./#overview-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports